// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".project[data-v-52b5d4da]{display:flex;align-items:center}", "",{"version":3,"sources":["/builds/hydra/intern/feedback-tool-www/src/components/fbt-project-small.vue"],"names":[],"mappings":"AAGA,0BACE,YAAA,CACA,kBAAA","file":"fbt-project-small.vue","sourcesContent":["\n@import '~colors';\n\n.project {\n  display: flex;\n  align-items: center;\n}\n"]}]);
// Exports
module.exports = exports;
